import { FC } from "react";

import { Box, Card, HStack, Text, VStack } from "@/components/ui";
import { useLocalization } from "@/hooks";
import { DemographicSetting } from "@/types/resources";

interface DemographicSettingsProps {
  demographics: DemographicSetting[];
}

const DemographicSettings: FC<DemographicSettingsProps> = ({
  demographics,
}) => {
  const { i18n } = useLocalization();

  return (
    <VStack className="space-y-1.5">
      {demographics.map((demographic, index) => (
        <Card
          key={index}
          className="space-y-2 py-2 px-2.5 rounded-xl border border-outline-200"
        >
          <Text className="text-xs font-medium text-typography-700">
            {demographic.label}
          </Text>
          <HStack className="flex-wrap gap-1">
            {demographic.distribution.map((dist) => {
              const pct = Math.round(dist.weight * 100);
              return (
                <HStack
                  className="items-center gap-1 px-2 py-0.5 rounded-lg bg-background-50 border border-outline-200"
                  key={dist.label}
                >
                  <Text className="text-[11px] text-typography-600">
                    {dist.label}
                  </Text>
                  <Box className="w-px h-2.5 bg-outline-200 mx-0.5" />
                  <Text className="text-[11px] font-semibold text-primary-600">
                    {i18n.numberToPercentage(pct, { precision: 0 })}
                  </Text>
                </HStack>
              );
            })}
            {(() => {
              const otherPct = Math.max(
                0,
                100 -
                  demographic.distribution.reduce(
                    (sum, d) => sum + Math.round(d.weight * 100),
                    0
                  )
              );
              return otherPct > 0 ? (
                <HStack className="items-center gap-1 px-2 py-0.5 rounded-lg bg-background-50 border border-dashed border-outline-200">
                  <Text className="text-[11px] text-typography-400">
                    {i18n.t("misc.otherValues")}
                  </Text>
                  <Box className="w-px h-2.5 bg-outline-200 mx-0.5" />
                  <Text className="text-[11px] font-semibold text-typography-400">
                    {i18n.numberToPercentage(otherPct, { precision: 0 })}
                  </Text>
                </HStack>
              ) : null;
            })()}
          </HStack>
        </Card>
      ))}
    </VStack>
  );
};

export default DemographicSettings;
